exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TriggerUpsellModal-d22005d9{cursor:pointer}\n", ""]);

// Exports
exports.locals = {
	"TriggerUpsellModal": "TriggerUpsellModal-d22005d9"
};